/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { observer } from "mobx-react";
import * as React from "react";

import { BaseShiftCard } from "../BaseShiftCard";

import { getBaseShiftCardProps } from "./CrossLocationShiftCard.mappers";
import { CrossLocationShiftCardProps } from "./CrossLocationShiftCardProps";
import { useCrossLocationTeamName } from "../../shiftDetails/CrossLocationTeamName.mappers";

/**
 * The modernized component to show a cross-location shift card shown in schedule and requests tabs.
 * Note: please use this component over 'Shift.tsx' which is being deprecated.
 * @param props The properties.
 */
export const CrossLocationShiftCard: React.FC<CrossLocationShiftCardProps> = observer(props => {
    const { teamId } = props;
    const teamName = useCrossLocationTeamName({ crossLocationTeamId: teamId });
    const shiftProps = getBaseShiftCardProps(props, teamName);

    return <BaseShiftCard {...shiftProps} />;
});
